import { useSelector } from 'react-redux';
import './Index.css';
import { Link, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import ErrorAdd from "../../../util/ErrorAdd";
import ReactJson from 'react-json-view'
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function Method() {

    const { url_controller, url_method } = useParams();

    const stateApi = useSelector((state) => state.api); //Размеры окна
    const [data, setData] = useState(null);
    //const [nameController, setNameController] = useState(null);

    const [loading, setLoading] = useState(false);
    const [log, setLog] = useState(null);

    useEffect(() => {
        //methodGetForSite
        if (stateApi.menu.filter(a => a.Url_Controller === url_controller & a.Url_Method === url_method).length > 0) {
            setLoading(true)
            const id_method = stateApi.menu.filter(a => a.Url_Controller === url_controller & a.Url_Method === url_method)[0].ID_Method;

            //setNameController(stateApi.controllers.filter(a => a.Url_Controller === url_controller)[0].Name_Controller)

            axios.get('/api_main/api/methodGetForSite', { params: { ID_Method: id_method } })
                .then((res) => {
                    if (res.data.Status === 1) {
                        setData(res.data.Data);

                    }
                    else {
                        setLog(res.data.Error);

                    }
                    setLoading(false);
                })
                .catch((err) => {
                    setLog('Неизвестная ошибка!');
                    setLoading(false);
                    ErrorAdd(err, window.location.href);
                });
        }

    }, [url_method, url_controller, stateApi.menu]);

    const myTheme = {
        root: '#fff', // фон всего вьюзера
        key: '#fff', // цвет ключей
        value: '#fff', // цвет значений
        // и так далее для всех элементов
    };


    console.log(data)
    return (
        <>
            {log !== null && <div className="form_error text-center mt-15">{log}</div>}
            {loading === true ? <div className="loader_01 mt-30"></div> : (
                data !== null &&
                (
                    <>
                        <div className='api_breadcrumb'>
                            <Link to={"/api/"} ><FontAwesomeIcon icon={faHouse} /></Link>
                            <div className='arrow'>/</div>

                            <Link to={"/api/" + url_controller} >{url_controller}</Link>
                            <div className='arrow'>/</div>
                            {data.Url}

                        </div>
                        <div className='api_method_header'>
                            <div>
                                <h1>{data.Name}</h1>
                                <div className='url'>
                                    {data.Url_Method}
                                    <div className={'http ' + data.Http_Method}>{data.Http_Method}</div>
                                    <div className='full_url'>
                                        {data.Full_Url}
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className='api_method_description'>
                            {data.Description}
                        </div>
                        <div className='api_method_parameter'>
                            <h3>Header parameters:</h3>
                            <div className='api_method_parameter_row'>
                                <div className='block_name'>
                                    <div className='name'> Authorization<div className='required'>*</div></div>
                                    <div className='type'></div>
                                </div>
                                <div className='block_text'>JWT Токен (пример: Authorization: eyJhbGciOiJIUzI1NiIsIn ...)</div>
                            </div>
                            <div className='api_method_parameter_row'>
                                <div className='block_name'>
                                    <div className='name'> v</div>
                                    <div className='type'></div>
                                </div>
                                <div className='block_text'>Версия метода (пример: v:{data.Version}). Если версия не указана, то по умолчанию будет взята последняя версия</div>
                            </div>
                        </div>

                        <div className='api_method_parameter'>
                            {data.Http_Method === 'GET' && <h3>Query parameters:</h3>}
                            {data.Http_Method === 'POST' && <h3>Body parameters:</h3>}

                            {data.Parameters.map(item => (
                                <div key={item.Name} className='api_method_parameter_row'>
                                    <div className='block_name'>
                                        <div className='name'>{item.Name} {item.Required && <div className='required'>*</div>}</div>
                                        <div className='type'>{item.Type}</div>
                                    </div>
                                    <div className='block_text'>{item.Description}</div>
                                </div>
                            ))}

                        </div>
                        {data.Response !== null && (
                            <>
                                <div className='api_method_parameter'>
                                    <h3>Response:</h3>
                                    <div className='api_method_parameter_row'>
                                        <div className='block_name'>
                                            <div className='name'> Status<div className='required'>*</div></div>
                                            <div className='type'>Int32</div>
                                        </div>
                                        <div className='block_text'>1-Запрос выполнен успешно; 0-Ошибка</div>
                                    </div>
                                    <div className='api_method_parameter_row'>
                                        <div className='block_name'>
                                            <div className='name'> Data</div>
                                            <div className='type'>Object</div>
                                        </div>
                                        <div className='block_text'>Данные, полученные в результате запроса</div>
                                    </div>
                                    <div className='api_method_parameter_row'>
                                        <div className='block_name'>
                                            <div className='name'> Error</div>
                                            <div className='type'>String</div>
                                        </div>
                                        <div className='block_text'>Описание ошибки запроса. Заполнено, когда Status=0</div>
                                    </div>
                                </div>
                                <div className='api_method_result'>
                                    <ReactJson src={JSON.parse(data.Response)} displayObjectSize={false} displayDataTypes={false} enableClipboard={false} name={null} collapsed={2} />
                                </div>
                            </>
                        )}
                    </>
                )
            )
            }

        </>
    );
}

export default Method;
